import script from "./ProfitLoss.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfitLoss.vue?vue&type=script&setup=true&lang=js"

import "./ProfitLoss.vue?vue&type=style&index=0&id=3edde89c&lang=scss"

const __exports__ = script;

export default __exports__